import SwapPanelProductReviews from './SwapPanelProductReviews';
export default SwapPanelProductReviews;
